import React from "react";
export const ErrorFileIcon: React.FC<any> = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      fill="none"
      version="1.1"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      {...props}
    >
      <defs>
        <clipPath id="master_svg0_245_18949">
          <rect x="0" y="0" width="40" height="40" rx="0" />
        </clipPath>
      </defs>
      <g clip-path="url(#master_svg0_245_18949)">
        <g>
          <path
            d="M4.00006103515625,34C4.00006103515625,37.3137,6.68635103515625,40,10.00006103515625,40L30.00006103515625,40C33.31376103515625,40,36.00006103515625,37.3137,36.00006103515625,34L36.00006103515625,10L26.00006103515625,0L10.00006103515625,0C6.68635103515625,0,4.00006103515625,2.68629,4.00006103515625,6L4.00006103515625,34Z"
            fill="#BEC2D3"
            fill-opacity="1"
          />
        </g>
        <g>
          <path
            d="M12,17C12,16.447715,12.447715,16,13,16L27,16C27.552300000000002,16,28,16.447715,28,17C28,17.55228,27.552300000000002,18,27,18L13,18C12.447715,18,12,17.55228,12,17ZM12,22C12,21.44772,12.447715,21,13,21L27,21C27.552300000000002,21,28,21.44772,28,22C28,22.55228,27.552300000000002,23,27,23L13,23C12.447715,23,12,22.55228,12,22ZM12,27C12,26.447699999999998,12.447715,26,13,26L27,26C27.552300000000002,26,28,26.447699999999998,28,27C28,27.552300000000002,27.552300000000002,28,27,28L13,28C12.447715,28,12,27.552300000000002,12,27Z"
            fill="#FFFFFF"
            fill-opacity="1"
          />
        </g>
        <g>
          <path
            d="M25.99993896484375,6C25.99993896484375,8.20914,27.79079896484375,10,29.99993896484375,10L35.99993896484375,10L25.99993896484375,0L25.99993896484375,6Z"
            fill="#FFFFFF"
            fill-opacity="0.4000000059604645"
          />
        </g>
      </g>
    </svg>
  );
};
